export default "__VITE_ASSET__DlPfbkdZ__"